// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import mapStyles from './_mapStyles';
import { loadGoogleMaps } from '../plugins/google-maps';
import runOnVisible from '../runner-visible';
import {watchVendorConsentUpdate} from '../plugins/cmp-helpers';
import {CONSENT_GOOGLE_MAPS} from '../consentVendors';
import {
  addConsentPlaceholder,
  removeConsentPlaceholder,
} from '../plugins/cmp-placeholder';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'location-map';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class LocationMap {
  /**
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.waypoint = null;
    this.gm = null;
    this.map = null;
    this.marker = null;
    this.infoWindow = null;

    this.coords = {
      lat: parseFloat(el.dataset.lat),
      lng: parseFloat(el.dataset.lng),
    };

    this.el = el;
    this.infoWindowContent = el.getElementsByClassName(`${baseClass}__info-window-content`)[0];
    this.inner = el.getElementsByClassName(`${baseClass}__inner`)[0];

    runOnVisible(this.el, () => {
      watchVendorConsentUpdate(CONSENT_GOOGLE_MAPS, async (hasConsent) => {
        if (hasConsent) {
          removeConsentPlaceholder(this.el);

          await this.initMap();
        } else {
          await addConsentPlaceholder(this.el, CONSENT_GOOGLE_MAPS);
        }
      });
    });
  }

  async initMap() {
    if (this.gm != null) {
      return;
    }

    const { maps } = await loadGoogleMaps();
    this.gm = maps;

    this.map = new this.gm.Map(this.inner, {
      center: this.coords,
      zoom: 16,
      disableDefaultUI: true,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: mapStyles,
    });

    this.marker = new this.gm.Marker({
      position: this.coords,
      icon: this.el.dataset.marker,
      map: this.map,
    });

    this.infoWindow = new this.gm.InfoWindow({
      content: this.infoWindowContent,
    });

    this.marker.addListener('click', () => {
      this.infoWindow.open({
        anchor: this.marker,
        map: this.map,
        shouldFocus: false,
      });
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  const locationMaps = document.querySelectorAll(`.${baseClass}:not(.${baseClass}--controlled)`);

  for (const locationMap of locationMaps) {
    new LocationMap(locationMap);
  }
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
